import IState from './Istate'
const currentDate = new Date();
let currentMonth: number|string = currentDate.getMonth() + 1;
currentMonth = currentMonth >= 10 ? currentMonth : '0' + currentMonth;


let state :IState = {
    currentPageName:"",
    showTab:false,
    accoData:{},
    curAccoData:{},
    cachedKeyboardHeight: 0,
    keyboardTrigger: '', // 键盘触发来源，临时方案，只是因为editor页面是被动接受键盘高度变化，所以非编辑区域的键盘也会影响到editor页面
    vipInfo: null,
    // 所有已购声音列表 包含付费声音、直接购买声音
    boughtSpeakerList: [],
    // 直接购买的发音人列表
    purchasedSpeakerList: [],
    appVersion: '',
};
export default state;
